/**
 * Legacy GA4 event names from clientportal-core/src/utils/gaAnalytics.ts (GAEventTypes).
 * Dashboards and funnels expect these exact kebab-case strings.
 */

export const LegacyGaEventNames = {
  CREATE_REACTIONS: 'create-reactions-event',
  DELETE_REACTIONS: 'delete-reactions-event',
  COMMENT_CREATED: 'comment-created-event',
  POST_CREATED: 'post-created-event',
  CHAT_MESSAGE_SENT: 'chat-message-sent-event',
  CHAT_MESSAGE_FAILED: 'chat-message-failed-event',
  CHAT_BLOCKED: 'chat-blocked-event',
  CHAT_CREATED: 'chat-created-event',
  EVENT_CREATED: 'event-created-event',
  EVENT_RSVP: 'event-rsvp-event',
  COMMUNITY_COURSE_OPENED: 'community-course-opened-event',
  GROUP_JOINED: 'group-joined-event',
  USER_BANNED: 'user-banned-event',
  MEDIA_REMOVED: 'media-removed-event',
  MEDIA_UPLOADED: 'media-uploaded-event',
  EVENT_ATTENDEES_LIST_EXPORTED: 'event-attendees-list-exported-event',
  EVENT_ATTENDEES_VIEWED: 'event-attendees-viewed-event',
  MEMBER_VIEWED_OWN_ANSWERS: 'member-viewed-own-answers-event',
  ADMIN_VIEWED_MEMBER_ANSWERS: 'admin-viewed-member-answers-event',
  GOKOLLAB_LISTING_JOINED: 'gokollab-listing-joined-event',
  GOKOLLAB_COMMUNITIES_VIEW: 'gokollab-communities-view-event',
  GOKOLLAB_COURSES_VIEW: 'gokollab-courses-view-event',
  GOKOLLAB_CREATORS_VIEW: 'gokollab-creators-view-event',
  GOKOLLAB_CATEGORY_SWITCH: 'gokollab-category-switch-event',
  GOKOLLAB_LISTING_VIEW: 'gokollab-listing-view-event',
  GOKOLLAB_COURSE_CREATE: 'gokollab-course-create-event',
  GOKOLLAB_COMMUNITY_CREATE: 'gokollab-community-create-event',
  GOKOLLAB_HOMEPAGE_LAND: 'gokollab-homepage-land-event',
  GOKOLLAB_SEARCH: 'gokollab-search-event',
  CREATOR_ACTIVITY_EVENT: 'creator-activity-event',
  USER_ACTIVITY_EVENT: 'user-activity-event',
  FOLLOW: 'follow-event',
  UNFOLLOW: 'unfollow-event',
  COURSE_MENTIONED: 'course-mentioned-event',
  EVENT_MENTIONED: 'event-mentioned-event',
  CHANNEL_MENTIONED: 'channel-mentioned-event',
  GO_LIVE_SESSION_JOINED: 'go-live-session-joined-event',
  LESSON_OPENED: 'lesson-opened-event',
  LESSON_COMPLETED: 'lesson-completed-event',
  NEXT_LESSON: 'next-lesson-event',
  CUSTOM_LOGIN_EVENT: 'custom-login-event',
  LOGOUT: 'logout-event',
  CERTIFICATE_DOWNLOAD: 'certificate-download-event',
} as const

export type LegacyGaEventName = (typeof LegacyGaEventNames)[keyof typeof LegacyGaEventNames]

/** Legacy events that route to creator-activity-event wrapper (trackCustomGAEvents). */
export const CREATOR_ACTIVITY_LEGACY_EVENTS: ReadonlySet<LegacyGaEventName> = new Set([
  LegacyGaEventNames.EVENT_CREATED,
  LegacyGaEventNames.USER_BANNED,
  LegacyGaEventNames.ADMIN_VIEWED_MEMBER_ANSWERS,
])

const NON_WRAPPED_LEGACY_EVENTS: ReadonlySet<LegacyGaEventName> = new Set([
  LegacyGaEventNames.CREATOR_ACTIVITY_EVENT,
  LegacyGaEventNames.USER_ACTIVITY_EVENT,
  LegacyGaEventNames.CUSTOM_LOGIN_EVENT,
])

/** Engagement events that receive creator/user activity wrapper before the specific event. */
export const LEGACY_WRAPPED_EVENT_NAMES: ReadonlySet<LegacyGaEventName> = new Set(
  (Object.values(LegacyGaEventNames) as LegacyGaEventName[]).filter(name => !NON_WRAPPED_LEGACY_EVENTS.has(name))
)
